import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/SkillPublishing';

import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';
import { PublishingPageDangerousOperation } from '../../types';

const t = i18n(keyset);

const DEFAULT_STATUS_DESCRIPTION: Record<DraftStatus, string> = {
    inDevelopment: t('status-in-dev'),
    reviewRequested: t('status-in-review'),
    reviewApproved: t('status-review-approved'),
    deployRequested: t('status-deploy'),
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: '',
    [DraftStatus.AppScanRequestedAfterModeration]: '',
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

const commonStatusDescriptionsAired: Record<DraftStatus, string> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    inDevelopment: t('aired-in-dev'),
    reviewRequested: t('aired-in-review'),
    reviewApproved: t('aired-review-approved'),
    deployRequested: t('aired-deploy'),
};

const smartHomeStatusDescriptions: Record<DraftStatus, string> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    devicesTesting: t('status-in-review'),
    devicesTestingCompleted: t('status-in-review'),
    meetingApproval: t('status-in-review'),
    waitingForTesting: t('status-in-review'),
};

const smartHomeStatusDescriptionsAired: Record<DraftStatus, string> = {
    ...commonStatusDescriptionsAired,
    devicesTesting: t('aired-in-review'),
    devicesTestingCompleted: t('aired-in-review'),
    meetingApproval: t('aired-in-review'),
    waitingForTesting: t('aired-in-review'),
};

const thereminvoxStatusDescriptions: Record<DraftStatus, string> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    deployRequested: t('theremin-deploy'),
};

const thereminvoxStatusDescriptionsAired: Record<DraftStatus, string> = {
    ...commonStatusDescriptionsAired,
    deployRequested: t('theremin-deploy'),
};

export const statusDescriptions: Record<Channel, Record<DraftStatus, string>> = {
    [Channel.AliceSkill]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.SmartHome]: smartHomeStatusDescriptions,
    [Channel.Thereminvox]: thereminvoxStatusDescriptions,
    [Channel.TvApp]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.SmartScreenApp]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.AutoApp]: DEFAULT_STATUS_DESCRIPTION,
};

export const statusDescriptionsAired: Record<Channel, Record<DraftStatus, string>> = {
    [Channel.AliceSkill]: commonStatusDescriptionsAired,
    [Channel.SmartHome]: smartHomeStatusDescriptionsAired,
    [Channel.Thereminvox]: thereminvoxStatusDescriptionsAired,
    [Channel.TvApp]: commonStatusDescriptionsAired,
    [Channel.SmartScreenApp]: commonStatusDescriptionsAired,
    [Channel.AutoApp]: commonStatusDescriptionsAired,
};

type DangerousOperationDescriptions = Record<PublishingPageDangerousOperation, string>;

const commonDangerousOperationsDescription: DangerousOperationDescriptions = {
    [PublishingPageDangerousOperation.Stop]: t('skill-stop-desc'),
    [PublishingPageDangerousOperation.Delete]: t('skill-delete-desc'),
};

const thereminvoxDangerousOperationsDescription: DangerousOperationDescriptions = {
    [PublishingPageDangerousOperation.Stop]: t('theremin-stop-desc'),
    [PublishingPageDangerousOperation.Delete]: t('theremin-delete-desc'),
};

export const dangerousOperations: Record<Channel, DangerousOperationDescriptions> = {
    [Channel.AliceSkill]: commonDangerousOperationsDescription,
    [Channel.AutoApp]: commonDangerousOperationsDescription,
    [Channel.SmartHome]: commonDangerousOperationsDescription,
    [Channel.SmartScreenApp]: commonDangerousOperationsDescription,
    [Channel.Thereminvox]: thereminvoxDangerousOperationsDescription,
    [Channel.TvApp]: commonDangerousOperationsDescription,
};
